var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_460_1264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#3478F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13513 7.33519V16.655L8.68004 11.9762L4.13513 7.33519ZM19.8648 7.33519V16.655L15.3425 11.9951L19.8648 7.33519ZM4.47924 6.91248H19.4912L13.5913 13.0558C13.3835 13.2722 13.1341 13.4443 12.8581 13.5619C12.5821 13.6795 12.2852 13.7401 11.9852 13.7401C11.6853 13.7401 11.3884 13.6795 11.1124 13.5619C10.8364 13.4443 10.587 13.2722 10.3792 13.0558L4.47924 6.91248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9316 13.3826C13.4254 13.9097 12.716 14.212 11.9852 14.212C11.2545 14.212 10.5451 13.9098 10.0389 13.3827L9.03817 12.3406L4.47925 17.0875H19.4912L14.9323 12.3406L13.9316 13.3826Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_460_1264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnread);
export default __webpack_public_path__ + "static/media/unread.af8d4045228b275cbcf7b4bd0ce554de.svg";
export { ForwardRef as ReactComponent };